import React from 'react';
import {
  Paper,
  Typography,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Alert,
} from '@mui/material';
import { CalculationParams, CalculationOptions } from '../../services/calculatedMetrics.service';

interface CalculationParamsPanelProps {
  params: Partial<CalculationParams>;
  options: Partial<CalculationOptions>;
  onParamsChange: (newParams: Partial<CalculationParams>) => void;
  loading: boolean;
  error: string | null;
}

export const CalculationParamsPanel: React.FC<CalculationParamsPanelProps> = ({ params, options, onParamsChange, loading, error }) => {

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    onParamsChange({ ...params, [name]: value });
  };

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>Ваші параметри</Typography>
      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item xs={12} sm={3}><TextField fullWidth label="Зріст (см)" name="height" value={params.height ?? ''} onChange={handleChange} type="number" disabled /></Grid>
        <Grid item xs={12} sm={3}><TextField fullWidth label="Вага (кг)" name="weight" value={params.weight ?? ''} onChange={handleChange} type="number" disabled /></Grid>
        <Grid item xs={12} sm={3}><TextField fullWidth label="Вік" name="age" value={params.age ?? ''} onChange={handleChange} type="number" disabled /></Grid>
        <Grid item xs={12} sm={3}>
          <FormControl fullWidth>
            <InputLabel>Стать</InputLabel>
            <Select name="gender" value={params.gender ?? ''} onChange={handleChange} label="Стать" disabled>
              {options.gender?.map(option => <MenuItem key={option} value={option}>{option}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Рівень активності</InputLabel>
            <Select name="activityLevel" value={params.activityLevel ?? ''} onChange={handleChange} label="Рівень активності">
              {options.activityLevel?.map(option => <MenuItem key={option} value={option}>{option}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Paper>
  );
};
